import styled from 'styled-components';

/**
 * Body text inside the drift modal. Plain paragraph styling — the modal
 * shell owns spacing, this just keeps the body text readable at the
 * panel's max width.
 */
export const Body = styled.div`
  font-size: 14px;
  line-height: 1.45;
  color: ${({ theme }) => theme.colors?.onSurface ?? '#E4E1E6'};
`;

/**
 * Footer row that holds the two primary actions. We deliberately
 * right-align: the visually-dominant button (Discard) sits on the
 * trailing edge so the safer action lives where the user expects the
 * confirm/primary button on this app's other modals.
 */
export const FooterRow = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing?.level2 ?? '8px'};
  justify-content: flex-end;
`;
